module.exports = __webpack_public_path__ + "img/pusher_item_1.9cfcc876.png";